import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const loadValueRestrictions = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const valueRestrictions = (await makeRequest('getValueRestrictions', { CDCONSUMIDOR }))?.data
    store.dispatch('setValueRestrictions', valueRestrictions)
}

const updateValueRestriction = async function (CDFAMILISALD, VRCONSDIARAL) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const updatedValueRestriction = (await makeRequest('updateValueRestriction', { CDCONSUMIDOR, CDFAMILISALD, VRCONSDIARAL }))?.data
    return updatedValueRestriction
}

const getUnrestrictedFamilies = async function () {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const unrestrictedFamilies = (await makeRequest('getUnrestrictedFamilies', { CDCONSUMIDOR }))?.data
    return unrestrictedFamilies
}

const addValueRestriction = async function (CDFAMILISALD, VRCONSDIARAL) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const newValueRestriction = (await makeRequest('addValueRestriction', { CDCONSUMIDOR, CDFAMILISALD, VRCONSDIARAL }))?.data

    return newValueRestriction
}

const deleteValueRestriction = async function (CDFAMILISALD) {
    const { CDCONSUMIDOR } = store.getters.getCurrDependent
    const deletedValueRestriction = (await makeRequest('deleteValueRestriction', { CDCONSUMIDOR, CDFAMILISALD }))?.data

    return deletedValueRestriction
}

export { loadValueRestrictions, updateValueRestriction, getUnrestrictedFamilies, addValueRestriction, deleteValueRestriction }
